import { EdytujSrodekModel } from '../projekty/spis/edytujSrodekModel';

export class WyslijOswiadczenieModel {
  srodki: Array<EdytujSrodekModel> = new Array();
}
